/* eslint-disable @typescript-eslint/no-explicit-any */

import { Form, TimePicker } from "antd";
import { Controller } from "react-hook-form";
import { InfoIconOutlined } from "../../CustomIcons";

export const TimePickerFieldNormal = ({
  fieldName,
  isRequired = false, // Provide default value
  label,
  validMessage,
  className,
  control,
  defaultValue, // Provide default value
  rules,
  tooltipTitle,
  optionalLabel,
  hintMessage,
  warning,
  validate,
}: any) => {
  return (
    <Form.Item
      required={isRequired}
      label={<div className="label_text">{label}</div>}
      validateStatus={validate}
      help={validMessage}
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          placement: "topLeft",
          arrow: false,
          icon: <InfoIconOutlined />,
        }
      }
    >
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <>
            <TimePicker
              value={value}
              format="HH:mm A"
              onChange={onChange}
              // changeOnScroll
              needConfirm={true}
              showNow={false}
            />
            {optionalLabel && (
              <div className="optional-label">{optionalLabel}</div>
            )}
            {hintMessage && (
              <div
                className={warning ? "hint-label warning-label" : "hint-label"}
              >
                {hintMessage}
              </div>
            )}
          </>
        )}
      />
    </Form.Item>
  );
};
